
import React, { useRef, useState } from "react";
import Input from "../../common/InputField";
import { FormControl, MenuItem, Select, styled, Checkbox, Box, Typography, Button } from "@mui/material";
import { ReactComponent as Dropdown } from "../../../assets/images/dropdown-arrow.svg";
import { ReactComponent as Check } from "../../../assets/images/check.svg";

function CompanyProfile() {
  const fileInputRef = useRef(null);
  const [logoUpload, setLogoUpload] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [businessName, setBusinessName] = useState("");
  const [website, setWebsite] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [industry, setIndustry] = useState("");
  const [companySize, setCompanySize] = useState("");
  const [audience, setAudience] = useState([]);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleLogoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setIsLoading(true);
      const fileURL = URL.createObjectURL(file);
      setLogoUpload(fileURL);
      setIsLoading(false);
    }
  };

  const handleAudienceChange = (label) => {
    setAudience((prev) =>
      prev.includes(label) ? prev.filter((item) => item !== label) : [...prev, label]
    );
  };

  const handleSave = () => {
    const payload = {
      businessName,
      website,
      city,
      country,
      industry,
      companySize,
      audience,
      logoUpload,
    };
    console.log("Saving profile:", payload);
    // later you can connect with API here
  };

  const selectStyle = {
    borderRadius: "8px",
    borderColor: "#D5DCE1",
    background: "#FFF",
    boxShadow: "0px 1px 2px 0px rgba(6, 21, 34, 0.05)",
    fontSize: "14px",
    width: "272px",
    height: "40px",
    cursor: "pointer",
    color: "#405261",
  };

  const BlueRoundedCheckbox = styled(Checkbox)(({ theme }) => ({
    padding: "0px",
    width: "18px",
    height: "18px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",


    "&.MuiCheckbox-root": {
      color: "transparent",
    },
    "& .MuiSvgIcon-root": {
      width: "18px",
      height: "18px",
      borderRadius: "4px",
      border: "1px solid #D5DCE1",
      backgroundColor: "#FFF",
      boxShadow: "0px 1px 2px 0px rgba(6, 21, 34, 0.05)",
      path: {
        display: "none",
      },
    },
    "&.Mui-checked": {
      "& .MuiSvgIcon-root": {
        border: "1px solid #148DFD",
        backgroundColor: "#FFF",
      },
    },
    "&:hover": {
      backgroundColor: "transparent",
      "& .MuiSvgIcon-root": {
        border: "1px solid #148DFD",
      },
    },
  }));

  const labelStyle = {
    color: "#405261",
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    lineHeight: "0px",
    fontWeight: 400,
  };

  // Options
  const countryOptions = ["Pakistan", "USA", "UK"];
  const industryOptions = ["IT", "Finance", "Healthcare"];
  const companySizeOptions = ["1-10", "11-50", "51-200"];
  const audienceOptions = ["B2B", "B2C", "Internal Use"];

  return (
    <>
      <div className="profile-main-container">
        <Box sx={{ paddingTop: "24px !important" }} className="Notification-Main-Container">
          {/* Left column - heading */}
          <Box>
            <Box className="Personal-Info-Text-Container">
              <Typography sx={{ marginTop: '7px !important', paddingBottom: '8px !important' }} className="Personal-Info-Text">Company Profile</Typography>
              <Typography
                // sx={{  }}
                className="notification-description"
                whiteSpace="pre-line"
              >
                Maintain a clear identity for your business {'\n'} across the platform.
              </Typography>
            </Box>
          </Box>

          {/* Right column - form */}
          <Box width="552px">
            <Box className="Personal-Information-Inputs">
              {/* Company Name */}
              <Box className="Spacing-Bottom">
                <Input
                  title="Company name"
                  placeholder="Enter your company name"
                  value={businessName}
                  onChange={(e) => setBusinessName(e.target.value)}
                />
              </Box>

              {/* Website */}
              <Box className="Spacing-Bottom">
                <Input
                  title="Website"
                  placeholder="https://www.abc.com"
                  value={website}
                  onChange={(e) => setWebsite(e.target.value)}

                />
              </Box>

              {/* City & Country */}
              <Box className="Spacing-Bottom" display="flex" gap={1}>
                <Input
                  title="City"
                  placeholder="Enter your city"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                />
                <Box>
                  <Typography className="input-div">Country</Typography>
                  <FormControl size="small" sx={{ ...selectStyle }}>
                    <Select
                      value={country}
                      onChange={(e) => setCountry(e.target.value)}
                      IconComponent={Dropdown}
                      displayEmpty
                      renderValue={(selected) =>
                        !selected ? <Typography sx={{ color: "#405261", fontSize: 14, fontFamily: "Inter", fontWeight: 400 }}>Select</Typography> : selected
                      }
                      sx={{
                        width: 272,
                        height: 40,
                        cursor: "pointer",
                        fontSize: 14,
                        color: "#405261",
                        "& .MuiSelect-select": { padding: "0px 12px" },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            border: "1px solid #D5DCE1",
                            mt: 0.5,
                            borderRadius: 1,
                            "& .MuiMenuItem-root": {
                              fontSize: 14,
                              px: 1.5,
                              py: 1,
                              color: "#556575",
                              backgroundColor: "transparent !important",
                              "&:hover": {
                                backgroundColor: "#F9FAFA !important",
                              },
                              "&.Mui-selected": {
                                color: "#061522",
                                backgroundColor: "#F9FAFA !important",
                                "&:hover": {
                                  backgroundColor: "#F9FAFA !important",
                                },
                              },
                            },
                          },
                        },
                      }}
                    >
                      {countryOptions.map((option) => (
                        <MenuItem key={option} value={option}>{option}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Box>

              {/* Industry & Company Size */}
              <Box className="Spacing-Bottom" display="flex" gap={1}>
                <Box>
                  <Typography className="input-div">Industry</Typography>
                  <FormControl size="small" sx={{ ...selectStyle }}>
                    <Select
                      value={industry}
                      onChange={(e) => setIndustry(e.target.value)}
                      IconComponent={Dropdown}
                      displayEmpty
                      renderValue={(selected) =>
                        !selected ? <Typography sx={{ color: "#405261", fontSize: 14, fontFamily: "Inter", fontWeight: 400 }}>Select</Typography> : selected
                      }
                      sx={{
                        width: 272,
                        height: 40,
                        cursor: "pointer",
                        fontSize: 14,
                        color: "#405261",
                        "& .MuiSelect-select": { padding: "0px 12px" },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            border: "1px solid #D5DCE1",
                            mt: 0.5,
                            borderRadius: 1,
                            "& .MuiMenuItem-root": {
                              fontSize: 14,
                              px: 1.5,
                              py: 1,
                              color: "#556575",
                              backgroundColor: "transparent !important",
                              "&:hover": {
                                backgroundColor: "#F9FAFA !important",
                              },
                              "&.Mui-selected": {
                                color: "#061522",
                                backgroundColor: "#F9FAFA !important",
                                "&:hover": {
                                  backgroundColor: "#F9FAFA !important",
                                },
                              },
                            },
                          },
                        },
                      }}
                    >
                      {industryOptions.map((option) => (
                        <MenuItem key={option} value={option}>{option}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>

                <Box>
                  <Typography className="input-div">Company Size</Typography>
                  <FormControl size="small" sx={{ ...selectStyle }}>
                    <Select
                      value={companySize}
                      onChange={(e) => setCompanySize(e.target.value)}
                      IconComponent={Dropdown}
                      displayEmpty
                      renderValue={(selected) =>
                        !selected ? <Typography sx={{ color: "#405261", fontSize: 14, fontFamily: "Inter", fontWeight: 400 }}>Select</Typography> : selected
                      }
                      sx={{
                        width: 272,
                        height: 40,
                        cursor: "pointer",
                        fontSize: 14,
                        color: "#405261",
                        "& .MuiSelect-select": { padding: "0px 12px" },
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            border: "1px solid #D5DCE1",
                            mt: 0.5,
                            borderRadius: 1,
                            "& .MuiMenuItem-root": {
                              fontSize: 14,
                              px: 1.5,
                              py: 1,
                              color: "#556575",
                              backgroundColor: "transparent !important",
                              "&:hover": {
                                backgroundColor: "#F9FAFA !important",
                              },
                              "&.Mui-selected": {
                                color: "#061522",
                                backgroundColor: "#F9FAFA !important",
                                "&:hover": {
                                  backgroundColor: "#F9FAFA !important",
                                },
                              },
                            },
                          },
                        },
                      }}
                    >
                      {companySizeOptions.map((option) => (
                        <MenuItem key={option} value={option}>{option}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Box>

              {/* Audience */}
              <Typography sx={{ paddingBottom: "8px !important", marginTop: "20px !important" }} className="Personal-Info-Text">
                Audience
              </Typography>
              {audienceOptions.map((option) => (
                <Box key={option} className="audienec-container" display="flex" alignItems="center" gap={1}>
                  <BlueRoundedCheckbox
                    color="primary"
                    checked={audience.includes(option)}
                    onChange={() => handleAudienceChange(option)}
                    checkedIcon={
                      <Check
                        style={{
                          width: 18,
                          height: 18,
                          borderRadius: 4,
                          border: "1px solid #148DFD",
                          backgroundColor: "#FFF",
                          padding: '5px 3px 2px 3.5px',
                        }}
                      />
                    }
                  />
                  <Typography sx={labelStyle}>{option}</Typography>
                </Box>
              ))}

              {/* Save Button */}
              <Button
                variant="contained"
                color="primary"
                className="Personal-Information-Save-Button"
                sx={{ mt: 15, textTransform: 'none' }}
                onClick={handleSave}
              >
                Save Changes
              </Button>
            </Box>
          </Box>
        </Box>
      </div>
    </>

  );
}

export default CompanyProfile;

